import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import Title from '../../components/title/Title';
import TooltipButton from '../../../../../components/tooltip-button/TooltipButton';
import { BUTTON_STYLES } from '../../../../../components/common-button/CommonButton';
import Icon from '../../../../../icons/Icon';
import { ICONS } from '../../../../../icons';
import { clearAdjustedMessages } from '../../../../../redux/activ8/activ8MessagesReducer';

import scss from './Header.module.scss';

function Header() {
  const dispatch = useDispatch();
  const { t } = useTranslation('activ8');

  const handleClearMessages = () => {
    dispatch(clearAdjustedMessages());
  };

  return (
    <div className={scss.header}>
      <Title title={t('generatedMessages')} />

      <div className={scss.actions}>
        <TooltipButton styleColor={BUTTON_STYLES.SECONDARY} maxWidth={120} onClick={() => null} disabled={true}>
          <Icon icon={ICONS.Reset} />
          {t('redoAll')}
        </TooltipButton>

        <TooltipButton styleColor={BUTTON_STYLES.SECONDARY} maxWidth={140} onClick={handleClearMessages}>
          <Icon icon={ICONS.Delete} />
          {t('deleteAll')}
        </TooltipButton>
      </div>
    </div>
  );
}

export default Header;
